import { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Box,
    Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'src/components/snackbar';
import Iconify from 'src/components/iconify';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { LoadingScreen } from 'src/components/loading-screen';

export const MaintenancegalleryModal = ({ open, onClose }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ images, setImages ] = useState([]);
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        getImages();
    }, [ open ]);

    const getImages = async () => {
        setLoading(true)
        const data = await getRequest(`${endpoints.admin_dashboard.product_updates.newsletter.get_modal_images}`);
        if (data) {
            setImages(data || []);
        }
        setLoading(false)
    };

    const handleCopyUrl = (imageUrl) => {
        navigator.clipboard.writeText(imageUrl).then(() => {
            enqueueSnackbar('Image URL Copied!', { variant: 'success' });
        });
    };

    const handleRemoveImage = async (imageUrl) => {
        try {
            setLoading(true)
            const response = await postRequest(
                endpoints.admin_dashboard.product_updates.newsletter.remove_modal_images,
                { file: imageUrl }, // Send URL to remove
                true
            );

            if (response.metadata.success) {
                enqueueSnackbar(response.metadata?.message || 'Image removed successfully!', { variant: 'success' });
                getImages();
                setLoading(false)

            }
        } catch {
            setLoading(false)
            enqueueSnackbar('Error removing image!', { variant: 'error' });
        }
    };

    return (
        <Dialog open={ open } onClose={ onClose } fullWidth maxWidth="md">
            <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                <span
                    className='cardColor'
                    style={ {
                        padding: '7px', marginLeft: '-25px', fontWeight: '700',
                        backgroundColor: "#F4F6F8",
                        color: '#637381'
                    } }
                >
                    &nbsp;&nbsp; Gallery &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                <IconButton onClick={ onClose }>
                    <Iconify icon="mdi:close" />
                </IconButton>
            </DialogTitle>

            { loading ? (
                <Box height={ 110 }>
                    <LoadingScreen />
                </Box>
            ) : (
                <DialogContent>
                    <Box sx={ { my: 3, display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' } }>
                        { images?.length > 0 ? (
                            images.map((imageUrl, index) => (
                                <Box
                                    key={ index }
                                    sx={ {
                                        position: 'relative',
                                        width: '150px',
                                        height: '150px',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        border: '1px solid #ddd',
                                        '&:hover .delete-icon': { opacity: 1 },
                                    } }
                                >
                                    <img
                                        src={ imageUrl }
                                        alt="uploaded"
                                        style={ { width: '100%', height: '100%', objectFit: 'cover' } }
                                        onClick={ () => handleCopyUrl(imageUrl) }
                                    />

                                    <IconButton
                                        className="delete-icon"
                                        onClick={ () => handleRemoveImage(imageUrl) }
                                        sx={ {
                                            position: 'absolute',
                                            top: '5px',
                                            right: '5px',
                                            background: 'rgba(255,255,255,0.8)',
                                            opacity: 0,
                                            transition: 'opacity 0.2s',
                                        } }
                                    >
                                        <Iconify icon="material-symbols:delete-outline-rounded" />
                                    </IconButton>
                                </Box>
                            ))
                        ) : (
                            <Typography variant="h6" sx={ { textAlign: 'center', color: 'gray', mt: 5 } }>
                                No images available
                            </Typography>
                        ) }
                    </Box>

                </DialogContent>) }

            <DialogActions>
                <Button variant="outlined" color="inherit" onClick={ onClose }>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
